import { render, staticRenderFns } from "./laststuSec.vue?vue&type=template&id=f4048c34&scoped=true&"
import script from "./laststuSec.vue?vue&type=script&lang=js&"
export * from "./laststuSec.vue?vue&type=script&lang=js&"
import style0 from "./laststuSec.vue?vue&type=style&index=0&id=f4048c34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4048c34",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
